// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607161034/js/" + chunkId + "." + {"44":"4e4c167a","225":"8f1ad8ff","481":"1006f9ea","486":"8b4e0fb0","770":"13d8965d"}[chunkId] + ".0.8593073694683444.chunk.js";
};